import React, { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { usePiping } from "../../PipingContext";
import { SpecInputs } from "./SpecInputs";
import { columns } from "./SpecColumns";
import { MaterialReactTable } from "material-react-table";
import {
  mrtBodyCellSx,
  mrtHeadCellSx,
  mrtSurfaceProps,
} from "../../../../../../styles/mrtThemeProps";

export function SpecTable() {
  const [tabIndex, setTabIndex] = useState(0);
  const { selectedSpecs, getSelectedSpecTable } = usePiping();
  const currentSelect = selectedSpecs[tabIndex];

  return (
    <>
      <SpecInputs selectIndex={tabIndex} />

      <Box sx={{ bgcolor: "background.paper", border: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, newIndex) => setTabIndex(newIndex)}
          sx={{
            bgcolor: "background.paper",
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          {selectedSpecs.map((item) => (
            <Tab label={item.label} key={item.label} />
          ))}
        </Tabs>
        <MaterialReactTable
          columns={columns}
          data={getSelectedSpecTable(currentSelect)}
          enableTopToolbar={true}
          enableStickyHeader={true}
          enableSorting={false}
          enableColumnResizing={true}
          columnResizeMode="onChange"
          layoutMode="grid"
          {...mrtSurfaceProps}
          muiTableContainerProps={{
            sx: {
              maxHeight: 600,
              width: "100%",
              backgroundColor: "background.paper",
            },
          }}
          muiTableProps={{
            sx: {
              tableLayout: "fixed",
              width: "100%",
            },
          }}
          muiTableBodyCellProps={{
            sx: {
              ...mrtBodyCellSx,
              borderRight: 1,
              fontSize: "0.65rem",
              padding: "4px 6px",
              verticalAlign: "top",
              lineHeight: "1.3",
              minHeight: "28px",
              height: "auto",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              wordWrap: "break-word",
              overflowWrap: "break-word",
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              ...mrtHeadCellSx,
              fontWeight: "bold",
              fontSize: "0.65rem",
              borderRight: 1,
              padding: "8px 6px",
              lineHeight: "1.3",
              whiteSpace: "normal",
              wordWrap: "break-word",
            },
          }}
          muiTableBodyRowProps={{
            sx: {
              height: "auto",
              backgroundColor: "background.paper",
              "&:nth-of-type(even)": {
                backgroundColor: "action.hover",
              },
              "& td": {
                height: "auto",
                padding: "4px 6px",
              },
            },
          }}
          initialState={{
            pagination: { pageSize: 50, pageIndex: 0 },
            density: "compact",
          }}
        />
      </Box>
    </>
  );
}
